import React from "react";

function RequiredDot(): JSX.Element {
  return (
    <div className="flex-1 ml-1 mt-1">
      <svg width="8" height="8" className="fill-current text-red-500">
        <circle cx="4" cy="4" r="4" />
      </svg>
    </div>
  );
}

export default RequiredDot;
